var _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPassion(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#ff0080",
    width: "80px",
    height: "80px",
    viewBox: "0 -1.5 44 44",
    xmlns: "http://www.w3.org/2000/svg",
    transform: "rotate(0)",
    stroke: "#ff0080",
    strokeWidth: 0.44000000000000006,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#CCCCCC",
    strokeWidth: 0.26399999999999996
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_39.Heart",
    "data-name": "39.Heart",
    d: "M24.8,43.648,24,44l-.8-.352C12.862,37.313,2,22.893,2,14.884A12.008,12.008,0,0,1,24,8.351a12.008,12.008,0,0,1,22,6.533C46,22.893,35.138,37.313,24.8,43.648ZM34,4.993a10.006,10.006,0,0,0-8.335,4.46L24,11.946,22.335,9.452A10.007,10.007,0,0,0,4,14.884C4,21.948,14.234,35.692,24,41.8c9.766-6.109,20-19.852,20-26.907A10,10,0,0,0,34,4.993Z",
    transform: "translate(-2 -3.002)",
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassion);
export default __webpack_public_path__ + "static/media/passion.4e686c18faca081536e632c3fa509465.svg";
export { ForwardRef as ReactComponent };